import Logger from 'customer-flows/utils/logger'

export default function buildFlowUrl(partnerKey: string, programId: string): string {
  if (!partnerKey || !programId) {
    Logger.error('Missing required parameters: partnerKey and programId')
    return ''
  }

  const safeKey = encodeURIComponent(partnerKey)
  const safeId = encodeURIComponent(programId)

  const base = new URL(window.location.origin)
  base.pathname = `/w/${safeKey}/${safeId}`

  return base.toString()
}
